"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function getJWTPayload(jwt) {
  try {
    var payload = jwt.split('.')[1];
    payload = window.atob(payload);
    payload = decodeURIComponent(payload);
    return JSON.parse(payload);
  } catch (error) {
    return;
  }
}

exports.getJWTPayload = getJWTPayload;